<template>
  <div class="container">
    <div class="btns">
      <div class="home" @click="$router.back(-1)">返回首页</div>
      <div class="date" @click="show = true">{{ date || '日期' }}</div>
    </div>
    <div class="title">捐赠记录</div>
    <div class="records">
      <div
        v-for="(item, index) in recordsList"
        :key="index"
        class="record"
        @click="toDetail(item)"
      >
        <div class="item">
          <div class="label">时间</div>
          <div class="value">{{ item.time }}</div>
        </div>
        <div class="item">
          <div class="label">芳名</div>
          <div class="value">{{ item.name }}</div>
        </div>
        <div class="item">
          <div class="label">金额</div>
          <div class="value">{{ item.money }}</div>
        </div>
      </div>
    </div>
    <van-calendar
      v-model="show"
      :min-date="minDate"
      :show-confirm="false"
      :max-date="maxDate"
      :default-date="maxDate"
      :show-mark="false"
      class="calendar"
      title="日期选择"
      poppable
      close-on-click-overlay
      safe-area-inset-bottom
      @select="onSelectDate"
    ></van-calendar>
  </div>
</template>

<script>
import dayjs from 'dayjs';
export default {
  name: '',
  components: {},
  data() {
    return {
      recordsList: [
        {
          time: '2026-04-20',
          name: '小王',
          money: 25000
        },
        {
          time: '2026-04-20',
          name: '小王',
          money: 25000
        },
        {
          time: '2026-04-20',
          name: '小王',
          money: 25000
        },
        {
          time: '2026-04-20',
          name: '小王',
          money: 25000
        },
        {
          time: '2026-04-20',
          name: '小王',
          money: 25000
        },
        {
          time: '2026-04-20',
          name: '小王',
          money: 25000
        },
        {
          time: '2026-04-20',
          name: '小王',
          money: 25000
        },
        {
          time: '2026-04-20',
          name: '小王',
          money: 25000
        },
        {
          time: '2026-04-20',
          name: '小王',
          money: 25000
        },
        {
          time: '2026-04-20',
          name: '小王',
          money: 25000
        },
        {
          time: '2026-04-20',
          name: '小王',
          money: 25000
        },
        {
          time: '2026-04-20',
          name: '小王',
          money: 25000
        }
      ],
      show: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(),
      date: ''
    };
  },
  created() {},
  mounted() {},
  methods: {
    toDetail(item) {
      this.$router.push({
        name: 'DonateDetail',
        query: {
          item: JSON.stringify(item)
        }
      });
    },
    onSelectDate(day) {
      console.log(day, 'day');
      this.show = false;
      this.date = dayjs(day).format('YYYY-MM-DD');
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #fbf4e2;
  display: flex;
  flex-direction: column;
  height: 100vh;

  .btns {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    padding: 15px 16px 21px 0px;
    box-sizing: border-box;
    .home,
    .date {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 16px;
      font-weight: 500;
    }
    .home {
      width: 96px;
      height: 34px;
      border-radius: 0 57px 57px 0;
      opacity: 1;
      background: #ab3a2a;
    }
    .date {
      min-width: 96px;
      height: 34px;
      border-radius: 6px;
      opacity: 1;
      background: #ab3a2a;
      padding: 0 16px;
      box-sizing: border-box;
    }
  }
  .title {
    height: 73px;
    background-image: url('~@/assets/images/bg-temple-record-title.png');
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    color: #ab3a2a;
    font-size: 24px;
    font-weight: 500;
    font-family: 'PingFang SC';
    line-height: 73px;
    letter-spacing: 15px;
    text-align: center;
    text-indent: 15px;
  }
  .records {
    flex: 1;
    overflow: hidden;
    overflow-y: scroll;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .record {
      width: 343px;
      height: 110px;
      border-radius: 6px;
      background: #91613b1a;
      padding: 16px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-bottom: 15px;
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 1.5;
        .label {
          color: #91613b;
          font-size: 16px;
          font-weight: 500;
        }
        .value {
          color: #91613b;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }
  .calendar {
    height: 400px;
  }
}
</style>
